import React, {useImperativeHandle, useRef} from 'react';
import {connect, useDispatch, useSelector} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {getStepNameSelector} from 'stores/selectors/wizardSelectors';

import withIntl from '../../lib/withIntl';
import './SetupWizard.scss';
import WizardFlagUI from './components/WizardFlagUI';
import {updateA1Offset} from '../../stores/business/instrumentBusiness';

import {SetupWizardStep, WizardFlag, WizardStatus} from '../../constants/SetupWizardEnum';
import {getSetupWizardFlagMessage} from '../../stores/business/setupWizardBusiness/commonSetupWizardBusiness';
import {checkTraySuitabilitySetupWizard} from '../../stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';
import {getStepContent} from './content/SetupWizardContentBusiness';

const mapStateToProps = (state) => ({
  wizardViewDataState: state.wizardState.wizardViewData,
  wizardStatusState: state.wizardState.wizardStatus,
  currentWizardViewState: state.wizardState.currentWizardView,
  appStateLoading: state.appState.loading.show,
  wizardFlagState: state.wizardState.wizardFlag,
});

const mapDispatchToProps = (dispatch) => ({
  instrumentBusinessUpdateA1Offset: bindActionCreators(updateA1Offset, dispatch),
  commonSetupWizardGetFlagMsg: bindActionCreators(getSetupWizardFlagMessage, dispatch),
});

const defaultNavigationOptions = {
  isChangeStep: true,
  isCheckContinueButtonAccess: true,
  isSkipSubstep: false,
};

const navigationOptionsPreventMove = {
  isChangeStep: false,
  isCheckContinueButtonAccess: false,
  isSkipSubstep: false,
};

const SetupWizardContent = React.forwardRef(
  ({intl, appStateLoading, wizardFlagState, commonSetupWizardGetFlagMsg, wizardStatusState}, ref) => {
    const dispatch = useDispatch();

    const stepName = useSelector(getStepNameSelector) || SetupWizardStep.WELCOME_SCREEN;
    const currentStepRef = useRef(null);

    useImperativeHandle(ref, () => ({
      async onContinue(skipStep) {
        const isTraySuitable = await dispatch(checkTraySuitabilitySetupWizard());
        let result = {};

        if (!isTraySuitable) {
          return navigationOptionsPreventMove;
        }

        if (currentStepRef.current?.onContinue) {
          result = await currentStepRef.current?.onContinue(skipStep);
        }

        return {...defaultNavigationOptions, ...result};
      },
      async onBack() {
        const isTraySuitable = await dispatch(checkTraySuitabilitySetupWizard());
        let result = {};

        if (!isTraySuitable) {
          return navigationOptionsPreventMove;
        }

        if (currentStepRef.current?.onBack) {
          result = await currentStepRef.current?.onBack();
        }

        return {...defaultNavigationOptions, ...result};
      },
    }));

    const isHideContent = () => wizardFlagState !== WizardFlag.NONE || appStateLoading;

    return (
      <div
        className={`setup-wizard-steps-container
        ${wizardStatusState === WizardStatus.NOT_STARTED ? 'full-height' : ''}
        ${wizardStatusState === WizardStatus.COMPLETED ? 'with-footer' : ''}`}
      >
        <WizardFlagUI
          flag={wizardFlagState}
          onGetFlagMsg={commonSetupWizardGetFlagMsg}
          hide={wizardFlagState === WizardFlag.NONE || appStateLoading}
        />
        <div className={`flex-column ${isHideContent() ? 'hidden' : ''} `}>
          {dispatch(getStepContent(currentStepRef, intl, stepName))}
        </div>
      </div>
    );
  },
);

SetupWizardContent.propTypes = {
  appStateLoading: PropTypes.any.isRequired,
  wizardFlagState: PropTypes.string.isRequired,
  commonSetupWizardGetFlagMsg: PropTypes.func.isRequired,
  wizardStatusState: PropTypes.string.isRequired,
  intl: PropTypes.any.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(withIntl(SetupWizardContent));
